export class IssueStateGroupFront {

    stateGroupKey: string;
    stateGroup: string;
}
